module.exports = __webpack_public_path__ + "img/filter-down.f2877d81.svg";